<template>
  <a-modal
    :title="title"
    :width="650"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    dialogClass="resize-for-mobile"
  >
    <a-spin :spinning="loading">
      <p
        style="text-align: center; font-size: 16px; color: black; display: block !important; margin-bottom: 10px"
        class="ant-form-item-label"
      >
        <label>{{ $t('disp.speciaAuth') }}</label
        ><span style="color: red">{{ $t('disp.allCompanyData') }}</span>
      </p>
      <a-form-model :form="form" @keyup.enter.native="handleOk">
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="this.$t('disp.viewable')">
          <j-input-popup
            :showTags="true"
            v-model="viewableUsers"
            :params="{ multiFlg: '1', departFlg: '1', selectUserList: viewableUsers }"
            component="SelectUserTreeModal"
            :placeholder="$t('disp.ph.select', [$t('disp.user')])"
            style="width: 100%"
          ></j-input-popup>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="this.$t('disp.editable')">
          <j-input-popup
            :showTags="true"
            v-model="editableUsers"
            :params="{ multiFlg: '1', departFlg: '1', selectUserList: editableUsers }"
            component="SelectUserTreeModal"
            :placeholder="$t('disp.ph.select', [$t('disp.user')])"
            style="width: 100%"
          ></j-input-popup>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { deleteAction, postAction, getAction } from '@/api/manage'
import JInputPopup from '@/components/JInputPopup'
import XEUtils from 'xe-utils'

export default {
  name: 'SpecialAuthModal',
  components: {
    JInputPopup,
  },
  props: {},
  data() {
    return {
      title: this.$t('disp.specialAuth'),
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 },
      },
      loading: false,
      //初期表示の参照可能ユーザIDリスト情報
      viewableUsersInitId: [],
      //初期表示の編集可能ユーザIDリスト情報
      editableUsersInitId: [],
      //画面表示の参照可能ユーザIDリスト情報
      viewableUsersId: [],
      //画面表示の編集可能ユーザIDリスト情報
      editableUsersId: [],
      viewableUsers: [],
      editableUsers: [],
      url: {
        getUserInitInfo: '/blaze-sys/k00/k0004/PermissionManage/getUserInitInfo',
        updateSpecialAuth: '/blaze-sys/k00/k0004/PermissionManage/updateSpecialAuth',
      },
    }
  },
  created() {},
  methods: {
    open() {
      this.getUserEditInfo()
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      var viewFlag = false
      if (this.viewableUsersInitId.length > 0) {
        //初期ユーザ情報あり
        viewFlag = true
      }

      let that = this
      //参照ユーザIDリスト（更新データ編集）
      var viewAddIds = ''
      that.viewableUsersId = []
      //参照可能者リスト
      that.viewableUsers.forEach((item) => {
        if (!viewFlag || !XEUtils.includes(that.viewableUsersInitId, item.value)) {
          viewAddIds += item.value + ','
        }
        that.viewableUsersId.push(item.value)
      })

      //参照ユーザIDリスト（削除データ編集）
      var viewDeleteIds = ''
      if (viewFlag) {
        //参照可能者リスト
        that.viewableUsersInitId.forEach((item) => {
          if (!XEUtils.includes(that.viewableUsersId, item)) {
            viewDeleteIds += item + ','
          }
        })
      }

      var editFlag = false
      if (that.editableUsersInitId.length > 0) {
        //初期ユーザ情報あり
        editFlag = true
      }

      //更新用編集ユーザIDリスト（更新データ編集）
      var editAddIds = ''

      that.editableUsersId = []
      //編集可能者リスト
      that.editableUsers.forEach((item) => {
        if (!editFlag || !XEUtils.includes(that.editableUsersInitId, item.value)) {
          editAddIds += item.value + ','
        }
        that.editableUsersId.push(item.value)
      })

      //更新用編集ユーザIDリスト（削除データ編集）
      var editDeleteIds = ''
      if (editFlag) {
        //編集可能者リスト
        that.editableUsersInitId.forEach((item) => {
          if (!XEUtils.includes(that.editableUsersId, item)) {
            editDeleteIds += item + ','
          }
        })
      }

      if (viewAddIds == '' && viewDeleteIds == '' && editAddIds == '' && editDeleteIds == '') {
        //更新情報なし
        that.close()
      } else {
        //更新情報あり
        postAction(that.url.updateSpecialAuth, {
          viewAddIds: viewAddIds,
          viewDeleteIds: viewDeleteIds,
          editAddIds: editAddIds,
          editDeleteIds: editDeleteIds,
        })
          .then((res) => {
            if (res.success) {
              that.$message.success(that.$t(res.message))
            }
          })
          .finally(() => {
            that.loading = false
            that.close()
          })
      }
    },
    handleCancel() {
      this.close()
    },
    /**
     * @description 初期化
     */
    getUserEditInfo() {
      if (this.loading) {
        return
      } else {
        this.loading = true
      }

      let that = this
      getAction(that.url.getUserInitInfo)
        .then((res) => {
          if (res.success) {
            //参照可能者初期表示リストを初期化にする
            that.viewableUsersInitId = []

            //参照可能者リスト
            that.viewableUsers = []
            var viewableUsersInfo = []
            if (res.result.viewableUsers != null) {
              viewableUsersInfo = res.result.viewableUsers
            }

            viewableUsersInfo.forEach((item) => {
              that.viewableUsers.push({
                value: item.id,
                text: item.realname,
              })
              //初期取得参照ユーザIDリスト
              that.viewableUsersInitId.push(item.id)
            })

            var editableUsersInfo = []
            if (res.result.editableUsers != null) {
              editableUsersInfo = res.result.editableUsers
            }

            //編集可能特別ユーザ初期表示リストを初期化にする
            that.editableUsersInitId = []

            //編集可能者リスト
            that.editableUsers = []
            editableUsersInfo.forEach((item) => {
              let editRow = Object.assign({
                value: item.id,
                text: item.realname,
              })
              that.editableUsers.push(editRow)
              //初期取得参照ユーザIDリスト
              that.editableUsersInitId.push(item.id)
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped></style>
